import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@bingads-webui-react/fabric-control';

export const FluctuationActionButton = ({
  i18n,
  actionType,
  onClick,
}) => (
  <React.Fragment>
    <span>|</span>
    {// eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link
        className="link-text"
        id={`fluctuation-${actionType}`}
        onClick={onClick}
      >
        {i18n.getString(`Fluctuation_Option_${actionType}`)}
      </Link>}
  </React.Fragment>);

FluctuationActionButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  actionType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
